import {
  isStockTakeBlockedByTypesenseDates,
  isStockTakeTypesenseDateCheckPending,
} from './stock-take-typesense-date.utils';

/**
 * When true, stock take list/schedule/detail are blocked until STOCK_INIT sync succeeds
 * and the Typesense schema includes `_stock_take_date` (never-counted items may still have a null date).
 */
export const STOCK_TAKE_SYNC_GATE_ENABLED = true;

/**
 * Returns true when stock taking must remain blocked for the current sync status.
 */
export function isStockTakeBlockedBySync(syncStatus: string | null | undefined): boolean {
  return STOCK_TAKE_SYNC_GATE_ENABLED && syncStatus != null && syncStatus !== 'SUCCESS';
}

/**
 * Returns true when stock take list/schedule/detail must remain blocked.
 */
export function isStockTakeModuleBlocked(
  syncStatus: string | null | undefined,
  typesenseMissingStockTakeDateCount: number | null,
  typesenseStockTakeDateSchemaReady: boolean | null,
): boolean {
  if (isStockTakeBlockedBySync(syncStatus)) {
    return true;
  }
  if (!STOCK_TAKE_SYNC_GATE_ENABLED || syncStatus !== 'SUCCESS') {
    return false;
  }
  if (isStockTakeTypesenseDateCheckPending(typesenseMissingStockTakeDateCount, typesenseStockTakeDateSchemaReady)) {
    return false;
  }
  return isStockTakeBlockedByTypesenseDates(
    typesenseMissingStockTakeDateCount,
    typesenseStockTakeDateSchemaReady,
  );
}
